import { createApp } from 'vue';
import OrfToWebpConverter from '../Components/OrfToWebpConverter.vue';

const root = document.getElementById('orf-to-webp-converter');
if (root) {
  createApp(OrfToWebpConverter).mount('#orf-to-webp-converter');
}
